import Checkbox, { CheckboxChangeHandler } from 'components/inputs/Checkbox';
import StdListContext from 'contexts/StdListContext';
import React from 'react';

interface Props {
  rowId: string;
  checked: boolean;
  indeterminate: boolean;
  disabled: boolean;
  onChange: CheckboxChangeHandler;
}

class StdListCheckbox extends React.Component<Props> {
  static defaultProps = {
    indeterminate: false,
    disabled: false,
  };

  handleChange: CheckboxChangeHandler = (checked, evt): void => {
    evt.stopPropagation();
    this.props.onChange(checked, evt);
  };

  render(): React.ReactNode {
    const { rowId, ...restProps } = this.props;
    return (
      <StdListContext.Consumer>
        {({ id: listId }): React.ReactNode => (
          <div className={`${listId}-checkbox pl3`}>
            <Checkbox
              id={`${listId}-${rowId}-std-list-checkbox`}
              {...restProps}
              onChange={this.handleChange}
            />
          </div>
        )}
      </StdListContext.Consumer>
    );
  }
}

export default StdListCheckbox;
